<h2 mat-dialog-title>{{data?.title}}</h2>
<mat-dialog-content class="mat-typography">
    <p><input #layoutname type="text" autoComplete="off" class="input-layout margin-left-right"
            title="Name of new layout version" [ngModel]="data.layoutname" (ngModelChange)="validate($event)"
            cdkFocusInitial></p>
    <div *ngIf="disableSaveButton" class="validation-status">
        {{validationStatus}}
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="color" mat-button [mat-dialog-close]="cancel()">Cancel</button>
    <span class="spacer"></span>
    <button class="color" mat-button [mat-dialog-close]="save()" [disabled]="disableSaveButton">Save</button>
</mat-dialog-actions>